module.exports = __webpack_public_path__ + "d4bbc4e82d36fbcd66b341990ae57423.svg";